export const navigation = [
  
  {
    text: 'Finance',
    role: 'Finance',
    path: '',
    icon: 'money',
    isExpanded: false,
    items: [
      {
        text: 'Register Merchant',
        path: 'register-merchant',
        role: 'RegisterMerchant',
        // icon: 'folder',
        isExpanded: true,
      },
      {
        text: 'Quick Actions',
        path: 'quick-actions',
        role: 'quick-actions',
        isExpanded: true,
      },
      {
        text: 'Ledger Dashboard',
        path: 'ledger',
        role: 'ledger',
        isExpanded: false
      },
      {
        text: 'Merchant Dashboard',
        path: 'merchants',
        role: 'Merchants',
        isExpanded: false,
      }
    ]
  }
  /*,
  {
    text: 'Admin Maintenance',
    path: 'admin',
    role : 'Admins',
    isExpanded: false,
    icon: 'group',
    items: [
      {
        text: 'Banks',
        path: 'bank',
        role : 'Bank',
        isExpanded: false,
      },
      {
        text: 'Countries',
        path: 'country',
        role : 'Country',
        isExpanded: false,
      },
      {
        text: 'Services',
        path: 'service',
        role : 'Service',
        isExpanded: false,
      },
      {
        text: 'Pricelists',
        path: 'pricelist',
        role : 'Pricelist',
        isExpanded: false,
      }
    ]
  }*/
];
